import { Component, EventEmitter, Input, Output } from '@angular/core';
const messages = require('./messages.json');

@Component({
	selector: 'app-password-validation',
	templateUrl: './password-validation.component.html',
	styleUrls: ['./password-validation.component.scss'],
})
export class PasswordValidationComponent {
	@Output() passwordItem = new EventEmitter<string>();
	@Output() validPassword = new EventEmitter<string>();
	@Input() currentPasswordValue = '';
	@Input() fieldLabel = '';
	fieldType = true;
	passwordValue: string;
	passwordModel: string;
	getErrorMessage: string;

	checkPasswordItem(value) {
		if (value) {
			this.passwordValue = value;
			this.currentPasswordValue
				? this.compareValues(this.passwordValue)
				: this.checkPasswordValidity(this.passwordValue);
		}
	}
	checkPasswordValidity(passwordValue) {
		if (this.passwordIsNull(passwordValue)) {
			this.setMessage('required');
		} else {
			this.passwordIsValid(passwordValue);
		}
	}

	passwordIsNull(password) {
		return !password || password == null;
	}

	passwordIsValid(password) {
		if (password?.length < 6) {
			this.setMessage('minlength');
		} else if (!password?.match(/^(?=.*[A-Z])/)) {
			this.setMessage('requiresACapitalLetter');
		} else if (!password?.match(/^(?=.*[!@#\$%\^&\*])/)) {
			this.setMessage('requiresASpecialCharacter');
		} else {
			this.getErrorMessage = '';
			return true;
		}
	}

	setMessage(message) {
		this.getErrorMessage = messages['password'][message] || '';
	}

	compareValues(newPass) {
		if (this.currentPasswordValue != newPass) {
			this.getErrorMessage = messages['confirm_password']['notEqual'] || '';
		} else {
			this.getErrorMessage = '';
			this.submitPassword(newPass);
		}
	}

	sendDataonFocusOut() {
		this.passwordItem.emit(this.passwordValue);
	}

	submitPassword(newPass) {
		if (this.passwordIsValid(newPass)) {
			this.validPassword.emit(newPass);
		}
	}

	changeFieldType() {
		this.fieldType = !this.fieldType;
	}
}
